import { render, staticRenderFns } from "./BonusAction.vue?vue&type=template&id=61d0c662&"
import script from "./BonusAction.vue?vue&type=script&lang=js&"
export * from "./BonusAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports